import React from 'react';

import { PerformanceReport } from '@ndvr/reporting-api';

import { formatCurrency, formatPercent } from 'utils';

import { EM_DASH, formatCompactCurrency, formatFullCurrency } from './format';
import { HeroStatCard, HeroStatProps } from './HeroStatCard';

interface SummaryKPICardProps {
    report?: PerformanceReport | null;
    isLoading?: boolean;
}

// The reporting page's headline KPIs in one card, above the sections: market value, net earnings,
// net return, realized and unrealized gains for the selected range and accounts.
export const SummaryKPICard = ({ report, isLoading }: SummaryKPICardProps) => {
    const marketValue = Number(report?.endingValue ?? 0);
    const netEarnings = Number(report?.netEarnings ?? 0);
    const netArr = report?.returnsPercentNet != null ? Number(report.returnsPercentNet) : undefined;
    const netArrText = netArr !== undefined ? formatPercent(netArr) : EM_DASH;
    const realized = Number(report?.realizedGains ?? 0);
    const unrealized = Number(report?.unrealizedGains ?? 0);

    const stats: HeroStatProps[] = [
        {
            label: 'Market Value',
            value: formatCurrency(marketValue),
            tooltip: formatFullCurrency(marketValue),
            glossaryKey: 'mv',
        },
        {
            label: 'Net Earnings',
            value: formatCompactCurrency(netEarnings),
            tooltip: formatFullCurrency(netEarnings),
            glossaryKey: 'ne',
            signedValue: netEarnings,
            showArrow: true,
        },
        {
            label: 'Net ARR',
            value: netArrText,
            tooltip: netArrText,
            glossaryKey: 'ann',
            signedValue: netArr,
            showArrow: true,
        },
        {
            label: 'Realized',
            value: formatCompactCurrency(realized),
            tooltip: formatFullCurrency(realized),
            signedValue: realized,
        },
        {
            label: 'Unrealized',
            value: formatCompactCurrency(unrealized),
            tooltip: formatFullCurrency(unrealized),
            signedValue: unrealized,
        },
    ];

    return <HeroStatCard stats={stats} isLoading={isLoading} />;
};
